function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M35.153,13.9l-2.767-.6a15.058,15.058,0,0,0-.89-2.147l1.532-2.383a1.076,1.076,0,0,0-.144-1.342l-4.31-4.31a1.076,1.076,0,0,0-1.342-.144L24.848,4.5a15.058,15.058,0,0,0-2.147-.89L22.1.847A1.076,1.076,0,0,0,21.048,0h-6.1A1.076,1.076,0,0,0,13.9.847l-.6,2.767a15.058,15.058,0,0,0-2.147.89L8.769,2.972a1.076,1.076,0,0,0-1.342.144l-4.31,4.31a1.076,1.076,0,0,0-.144,1.342L4.5,11.152a15.058,15.058,0,0,0-.89,2.147l-2.767.6A1.076,1.076,0,0,0,0,14.952v6.1A1.076,1.076,0,0,0,.847,22.1l2.767.6a15.058,15.058,0,0,0,.89,2.147L2.973,27.23a1.076,1.076,0,0,0,.144,1.342l4.31,4.31a1.076,1.076,0,0,0,1.342.144L11.152,31.5a15.059,15.059,0,0,0,2.147.89l.6,2.767A1.076,1.076,0,0,0,14.952,36h6.1a1.076,1.076,0,0,0,1.051-.847l.6-2.767a15.058,15.058,0,0,0,2.147-.89l2.383,1.532a1.076,1.076,0,0,0,1.342-.144l4.31-4.31a1.076,1.076,0,0,0,.144-1.342L31.5,24.848a15.058,15.058,0,0,0,.89-2.147l2.767-.6A1.076,1.076,0,0,0,36,21.048v-6.1A1.076,1.076,0,0,0,35.153,13.9ZM24.454,18A6.454,6.454,0,1,1,18,11.546,6.462,6.462,0,0,1,24.454,18Zm0,0",
  transform: "translate(0 0)"
});

const SvgIconSettings = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Settings.041c238c.svg";
export { ForwardRef as ReactComponent };